import React from 'react';

import { Provider } from "react-redux";
import { useLocation } from "react-router-dom";

import SentDetailContainer from "./container/SentDetailContainer";

import configure from '../../store/configure';
import Layout from "../../component/layout/Layout";

const SentDetailPage = () => {

    const path = useLocation().pathname.split("/");
    const uid = path[3];

    return (
        <Provider store={configure}>
            <Layout>
                <SentDetailContainer
                    uid={uid}
                />
            </Layout>
        </Provider>
    );
};

export default SentDetailPage;
